import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './lib/flexible'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import service, { user, work, draft, order ,upload } from './api'

import wx from 'weixin-js-sdk'
Vue.prototype.$wx = wx

// 混入
import _mixin from "@/mixins/index.js";
Vue.mixin(_mixin);

Vue.config.productionTip = false

Vue.use(ElementUI)
// 挂载API到Vue原型
Vue.prototype.$api = {
  user,
  work,
  draft,
  order,
  upload
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
